export function formatFulfillmentStatus(status) {
  switch(status) {
    case "dispatch": return "Dispatch";
    case "in_transit": return "In Transit";
    case "in_delivery": return "In Delivery";
    case "packaged": return "Packaged";
    case "pickup": return "Pickup";
    case "delivered": return "Delivered";
    case "partially_delivered": return "Partially Delivered";
    case "voided": return "Voided";
    case "failed": return "Failed";
    case "exception": return "Exception";
    case "manifest_pickup": return "Manifest Pickup";
    case "packaging": return "Packaging";
    case "cancelled": return "Cancelled";
    case "not_delivered": return "Not Delivered";
    case "replaced": return "Replaced";
    case "partially_replaced": return "Partially Replaced";
    default:
      return status;
  }
}

export function isInTransit(status) {
  return status === "in_transit";
}